export default __webpack_public_path__ + "static/media/slide-a.1727dc5d.jpg";